export function getDescriptions() {
    let descripciones = {};
    descripciones["ntt_xbox-series-s-fusion"] = "La consola de última generación al mejor precio del mercado.";
    descripciones["ntt_ps5-fifa2023-ds-gt7-ultimate-spiderman-fusion"] = "Tiempos de carga mínimos, interacciones hiperrealistas y audio 3D en una consola que te dejará sin aliento. Llévatela con la nueva versión de FIFA 23 y 2 juegos más";
    descripciones["ntt_meta-quest-2-fusion"] = "Adéntrate en el universo de la realidad virtual con estas gafas inalámbricas de última generación; solo tienes que definir tu espacio de juego y adentrarte en mundos totalmente inmersivos que desafían la imaginación.";
    descripciones["ntt_ps5-dualsense-gran-turismo7-horizon-forbidden-west-ultimate-spiderman-fusion"] = "Ahora tienes tu Play Station 5 con DualSense, Gran Turismo 7,Horizon Forbidden West y Ultimate Spiderman 825 GB al mejor precio";
    descripciones["ntt_nintendo-switch-mario-kart-8-sports-fusion"] = "La consola portátil perfecta para jugar en familia.";
    
    descripciones["ntt_meta-quest-2-fusion"] = "Adéntrate en la realidad virtual con estas gafas y pon a prueba tus habilidades.";
    
    descripciones["ntt_xbox-series-x-call-of-duty-modern-warfare-2-mando-fusion"] = "La consola más potente con una nueva misión junto a la Fuerza operativa 141.";
    descripciones["ntt_meta-quest-2-resident-evil-beat-saber-fusion"] = "Disfruta al máximo de <b>experiencias 360º</b> con tus Meta Quest 2, tus gafas de <b>realidad virtual de última generación</b>, y los juego Beat Saber y Resident Evil ¡de regalo!";
    descripciones["ntt_xbox-series-s-gilded-hunter-fusion"] = "La consola más accesible incluye 3 juegos con contenido premium adicional.";
    descripciones["ntt_xbox-seriesx-fifa23-mando-fusion"] = "Fanático del fútbol, este es tu pack. Juega como nunca antes con los <b>12 teraflops de potencia</b> de procesamiento de la Xbox Series X y llévate FIFA 23 y un mando Mineral Camo <b>¡gratis!</b>";
    descripciones["ntt_ps5-god-of-war-last-of-us-horizon-fusion"] = "<b>Velocidad ultraalta, realismo nunca visto y tecnología audio 3D</b> con tu PlayStation 5. Eligela con la secuela del aclamado God of War, The Last of Us Parte I y el épico juego de rol Horizon Forbidden West.";
    
    descripciones["ntt_meta-quest-2-resident-evil4-fusion"] = "Descubre la realidad virtual, los gráficos ultrarrealistas y el sonido 3D con este pack de Meta Quest 2 que incluye juegos de terror, disparos en primera persona y golf.";
    descripciones["ntt_playstation-vr2-sense-horizon-call-of-the-mountain-fusion"] = "Las gafas virtuales de última generación para tu PS5.";
    descripciones["ntt_ps5-dualsense-fusion"] = "La consola más deseada junto a dos mandos con retroalimentación háptica.";
    descripciones["ntt_pico-4-fusion"] = "El casco de realidad virtual con tecnología innovadora con dos juegos de regalo.";
    return descripciones;
}

export function getMoreInfo(alias) {
    let item = "";
    if(alias.indexOf("series-s") > -1){                
        item = "https://www.movistar.es/particulares/gaming/xbox-s-series/";
    }else if(alias.indexOf("seriesx") > -1 || alias.indexOf("series-x") > -1){                
        item = "https://www.movistar.es/particulares/gaming/xbox-x-series/";
    }else if(alias.indexOf("meta") > -1){                
        item = "https://www.movistar.es/particulares/gaming/meta-quest-2/";
    }else if(alias.indexOf("ps5") > -1 || alias.indexOf("playstation") > -1){     
        if(alias != "ntt_sony-ps5-hogwarts-legacy-fusion"){
            item = "https://www.movistar.es/particulares/gaming/ps5/";
        }
    }else if(alias.indexOf("nintendo-switch-oled") > -1){ 
        item = "https://www.movistar.es/particulares/gaming/nintendo-switch-oled/";
    }else if(alias.indexOf("nintendo") > -1){ 
        item = "https://www.movistar.es/particulares/gaming/nintendo-switch/";
    }
    return item;
}

export function getItemsAdicionales(dispositivos, others){


    fetch("https://catalogue.col.movistar.es/api/terminal/v1/getAllItem?idPeticion=VT116A0B4EF61B11ED92340123456789AB&segment=FUSION_AV_ADDITIONAL&type=gaming")
        .then((response) => response.json())
        .then((data) => {
  
          for (let i = 0; i < data["gaming"].length; i++) {

            console.log(data);
  
            let precio1min = 1000000;
  
            if(parseFloat(data["gaming"][i]["offers"][0]["pvp_fusion_av"]) < precio1min){
                precio1min = data["gaming"][i]["offers"][0]["pvp_fusion_av"];
            }                        
            
            if(parseFloat(data["gaming"][i]["offers"][0]["pvp_fusion_bv"]) < precio1min){
                precio1min = data["gaming"][i]["offers"][0]["pvp_fusion_bv"];
            }
  
            if(parseFloat(data["gaming"][i]["offers"][0]["pvp_fusion_mv"]) < precio1min){
                precio1min = data["gaming"][i]["offers"][0]["pvp_fusion_mv"];
            }
  
            for (let x = 0; x < dispositivos.length; x++) {
              if(dispositivos[x]["alias"] == data["gaming"][i]["alias"]){
                dispositivos[x]["precionopromo"] = precio1min.replace(",",".");
              }
  
            }
  
          }

  
          for (let i = 0; i < data["gaming"].length; i++) {
  
            let precio1min = 1000000;
  
            if(parseFloat(data["gaming"][i]["offers"][0]["pvp_fusion_av"]) < precio1min){
                precio1min = data["gaming"][i]["offers"][0]["pvp_fusion_av"];
            }                        
            
            if(parseFloat(data["gaming"][i]["offers"][0]["pvp_fusion_bv"]) < precio1min){
                precio1min = data["gaming"][i]["offers"][0]["pvp_fusion_bv"];
            }
  
            if(parseFloat(data["gaming"][i]["offers"][0]["pvp_fusion_mv"]) < precio1min){
                precio1min = data["gaming"][i]["offers"][0]["pvp_fusion_mv"];
            }
  
            for (let x = 0; x < others.length; x++) {
  
              if(others[x]["alias"] == data["gaming"][i]["alias"]){
                others[x]["precionopromo"] = precio1min.replace(",",".");;
              }
  
            }
  
          }

            return [dispositivos, others, data];
  
        });

  
  }
  
  